import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkedAlt, faLightbulb, faImages, faUtensils, faTrophy, faCartShopping, faHeart } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "./css/BotonesHome.css";
import TarjetaDestacada from "./TarjetaDestacada";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import { ROLES } from "../../utils/roles";

const botones = [
    { titulo: "Viajes", ruta: "/viajes", icono: faMapMarkedAlt },
    { titulo: "Ideas", ruta: "/ideas", icono: faLightbulb },
    { titulo: "Galería", ruta: "/galeria", icono: faImages },
    { titulo: "Recetas", ruta: "/recetas", icono: faUtensils },
    { titulo: "Ranking", ruta: "/ranking", icono: faTrophy },
    { titulo: "Compra", ruta: "/lista-compra", icono: faCartShopping },
    { titulo: "Amore", ruta: "/contador", icono: faHeart, adminOnly: true },
];

const BotonesHome = () => {
    const { userRole, authReady, isWhitelistedAdmin } = useSelector((state: RootState) => state.auth);
    const isAdmin = authReady && userRole === ROLES.A12_B && isWhitelistedAdmin;

    const botonesVisibles = botones.filter(btn => {
        if (btn.adminOnly) {
            return isAdmin;
        }
        return true;
    });

    return (
        <Fragment>
            <div className="botones-home">
                {botonesVisibles.map((btn, index) => (
                    <Link
                        key={index}
                        to={btn.ruta}
                        className={`boton-home-card${btn.adminOnly ? " admin-only" : ""}`}
                    >
                        <span className="icon-wrap">
                            <FontAwesomeIcon icon={btn.icono} className="boton-icono" />
                        </span>
                        <span>{btn.titulo}</span>
                    </Link>
                ))}
            </div>
            <TarjetaDestacada />
        </Fragment>
    );
};

export default BotonesHome;
